module.exports = __webpack_public_path__ + "img/Football .80d102d6.webp";